(function () {
  'use strict';

  var id = 'status';

  // Add onto the wsLrs.cards module...
  angular.module('wsLrs.cards').factory(id + '.Utils', ['CardQueryResource', 'ChartUtils', '$routeParams', 'Utils', 'QueryES', function (CardQueryResource, ChartUtils, $routeParams, Utils, QueryES) {
    var addRouteParams = function addRouteParams(params) {
      params.personId = params.personId || $routeParams.personId;
      params.groupId = $routeParams.groupId;
      if ($routeParams.activityId) {
        params.activityId = decodeURIComponent($routeParams.activityId);
      }
      params.statusId = !_.isUndefined(params.statusId) ? params.statusId : null || _.isNumber($routeParams.statusId) ? $routeParams.statusId : null;
    };
    var self = {
      fetchData: function fetchData(cardId, cardToPreview, params) {
        var path = "/status/data";
        params = params || {};
        addRouteParams(params);
        return CardQueryResource.get(path, cardId, params, cardToPreview);
      },
      fetchResultData: function fetchResultData(cardId, cardToPreview, params) {
        var path = "/status/result";
        params = params || {};
        addRouteParams(params);
        return CardQueryResource.get(path, cardId, params, cardToPreview);
      },
      fetchPeopleData: function fetchPeopleData(cardId, cardToPreview, params) {
        var path = "/status/people";
        params = params || {};
        addRouteParams(params);
        return CardQueryResource.get(path, cardId, params, cardToPreview);
      },
      fetchGroupData: function fetchGroupData(cardId, cardToPreview, params, entity) {
        var path = "/status/groups";
        params = params || {};
        addRouteParams(params);
        if (params.personId && entity && entity.parentGroupIds) {
          delete params.personId;
          params.groupId = entity.parentGroupIds;
        } else if (params.groupId) {
          params.parentGroupId = params.groupId;
          delete params.groupId;
        }
        return CardQueryResource.get(path, cardId, params, cardToPreview);
      },
      fetchActivityData: function fetchActivityData(cardId, cardToPreview, params) {
        var path = "/status/activities";
        params = params || {};
        addRouteParams(params);
        return CardQueryResource.get(path, cardId, params, cardToPreview);
      },
      fetchStatusStateData: function fetchStatusStateData(cardId, cardToPreview, params) {
        var path = "/status/states";
        params = params || {};
        addRouteParams(params);
        return CardQueryResource.get(path, cardId, params, cardToPreview);
      },
      getDetailURL: function getDetailURL(entity, id) {
        var url;
        if (entity === 'group' && $routeParams.activityId || entity === 'activity' && $routeParams.groupId) {
          url = "#/status/" + $routeParams.cardId + "/group/" + (entity === 'group' ? id : $routeParams.groupId) + "/activity/" + (entity === 'activity' ? encodeURIComponent(encodeURIComponent(id)) : encodeURIComponent($routeParams.activityId));
        } else {
          url = "#/status/" + $routeParams.cardId + "/" + entity + "/" + encodeURIComponent(encodeURIComponent(id));
        }
        if ($routeParams.shareKey) {
          url += '?shareKey=' + $routeParams.shareKey;
        }
        return url;
      },
      getCsvDownloadUrl: function getCsvDownloadUrl(entity, cardId, config, params) {
        params = params || {};
        addRouteParams(params);
        var url = CardQueryResource.getDownloadUrl('/status/' + entity + '/csv', cardId, config);
        return Utils.appendParams(url, params);
      },
      getStatementDownloadUrl: function getStatementDownloadUrl(cardId) {
        return QueryES.queryExportUrl(cardId, true, id);
      },
      getStatusPieChart: function getStatusPieChart(data, config) {
        var chart = {
          chart: {
            type: 'pie',
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false
          },
          title: {
            text: null
          },
          tooltip: {
            headerFormat: '',
            pointFormat: '<b>{point.name}:</b> <div>{point.percentage:.1f}%</div>'
          },
          legend: {
            labelFormat: '<b>{name}</b>: {percentage:.1f} %'
          },
          plotOptions: {
            pie: {
              allowPointSelect: false,
              cursor: 'pointer',
              dataLabels: {
                enabled: false
              },
              showInLegend: true
            }
          },
          series: [{
            type: 'pie',
            name: "Status",
            data: _.map(data, function (s, i) {
              return {
                name: config.statuses[i].name,
                color: ChartUtils.getSeriesColor(config, i),
                y: s.count
              };
            })
          }]
        };
        return chart;
      },
      getResultPieChart: function getResultPieChart(result, config) {
        var title = (result.averageCompletion * 100).toFixed(1) + '%';
        if ($routeParams.activityId && $routeParams.groupId) {
          title += ' of people in this group assigned to this course have completed it.';
        } else if ($routeParams.activityId) {
          title += ' of people assigned to this course have completed it.';
        } else if ($routeParams.groupId) {
          title += ' of people in this group have completed their assigned courses.';
        } else if ($routeParams.personId) {
          title = result.personName + ' has completed ' + title + ' of assigned courses.';
        } else {
          title += ' of people have completed their assigned courses.';
        }
        var chart = {
          chart: {
            type: 'pie',
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false
          },
          title: {
            text: title,
            style: {
              'text-align': 'center'
            },
            align: 'center'
          },
          tooltip: {
            headerFormat: '',
            pointFormat: '<b>{point.y} {point.name}:</b><div>{point.percentage:.1f}%</div>'
          },
          plotOptions: {
            pie: {
              allowPointSelect: false,
              dataLabels: {
                enabled: false
              },
              showInLegend: true
            }
          },
          legend: {
            labelFormat: '{name}'
          },
          series: [{
            type: 'pie',
            name: "Status",
            data: [{
              name: ($routeParams.personId ? "Courses" : "People") + " Complete",
              color: ChartUtils.getSeriesColor(config, 0, 'green'),
              y: result.complete
            }, {
              name: ($routeParams.personId ? "Courses" : "People") + " Not Complete",
              color: ChartUtils.getSeriesColor(config, 1, 'red'),
              y: result.notComplete
            }]
          }]
        };
        return chart;
      },
      getCompletionBarChart: function getCompletionBarChart(entity, config) {
        return {
          chart: {
            type: 'bar',
            margin: [0, 0, 0, 0],
            height: '30px'
          },
          title: {
            text: null
          },
          tooltip: {
            headerFormat: '',
            pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>'
          },
          xAxis: {
            lineWidth: 0,
            minorGridLineWidth: 0,
            lineColor: 'transparent',
            minorTickLength: 0,
            tickLength: 0,
            labels: {
              enabled: false
            },
            min: 0,
            categories: ['']
          },
          yAxis: {
            lineWidth: 0,
            minorGridLineWidth: 0,
            lineColor: 'transparent',
            minorTickLength: 0,
            tickLength: 0,
            gridLineColor: 'transparent',
            title: {
              text: null
            },
            labels: {
              enabled: false
            }
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            bar: {
              stacking: 'percent',
              groupPadding: 0.1,
              pointWidth: 30
            }
          },
          series: [{
            name: 'Not Complete',
            pointWidth: 30,
            color: ChartUtils.getSeriesColor(config, 1, 'red'),
            data: [entity.notComplete]
          }, {
            name: 'Complete',
            pointWidth: 30,
            color: ChartUtils.getSeriesColor(config, 0, 'green'),
            data: [entity.complete]
          }]
        };
      },
      getCompletionBarChartLegend: function getCompletionBarChartLegend(entity, config) {
        return {
          chart: {
            type: 'bar',
            margin: [0, 0, 0, 0],
            height: '100px'
          },
          title: {
            text: null
          },
          tooltip: {
            enabled: false
          },
          xAxis: {
            visible: false
          },
          yAxis: {
            visible: false
          },
          legend: {
            enabled: true,
            verticalAlign: 'top'
          },
          plotOptions: {
            bar: {
              stacking: 'percent',
              groupPadding: 0,
              pointWidth: 0
            }
          },
          series: [{
            name: '% of ' + entity + ' Not Complete',
            color: ChartUtils.getSeriesColor(config, 1, 'red'),
            data: []
          }, {
            name: '% of ' + entity + ' Complete',
            color: ChartUtils.getSeriesColor(config, 0, 'green'),
            data: []
          }]
        };
      },
      getStatusBarChart: function getStatusBarChart(entity, config) {
        return {
          chart: {
            type: 'bar',
            margin: [0, 0, 0, 0],
            height: '30px'
          },
          title: {
            text: null
          },
          tooltip: {
            headerFormat: '',
            pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>'
          },
          xAxis: {
            lineWidth: 0,
            minorGridLineWidth: 0,
            lineColor: 'transparent',
            minorTickLength: 0,
            tickLength: 0,
            labels: {
              enabled: false
            },
            min: 0,
            categories: ['']
          },
          yAxis: {
            lineWidth: 0,
            minorGridLineWidth: 0,
            lineColor: 'transparent',
            minorTickLength: 0,
            tickLength: 0,
            gridLineColor: 'transparent',
            title: {
              text: null
            },
            labels: {
              enabled: false
            }
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            bar: {
              stacking: 'percent',
              groupPadding: 0.1,
              pointWidth: 30
            }
          },
          series: _.map(config.statuses, function (s, sIdx) {
            return {
              name: s.name,
              pointWidth: 30,
              color: ChartUtils.getSeriesColor(config, sIdx),
              data: [entity.statuses[sIdx]]
            };
          })
        };
      },
      getStatusBarChartLegend: function getStatusBarChartLegend(config) {
        return {
          chart: {
            type: 'bar',
            margin: [0, 0, 0, 0],
            height: '100px'
          },
          title: {
            text: null
          },
          tooltip: {
            enabled: false
          },
          xAxis: {
            visible: false
          },
          yAxis: {
            visible: false
          },
          legend: {
            enabled: true,
            verticalAlign: 'top'
          },
          plotOptions: {
            bar: {
              stacking: 'percent',
              groupPadding: 0,
              pointWidth: 0
            }
          },
          series: _.map(config.statuses, function (s, sIdx) {
            return {
              name: s.name,
              color: ChartUtils.getSeriesColor(config, sIdx),
              data: []
            };
          })
        };
      }
    };
    return self;
  }]).config(['$routeProvider', function ($routeProvider) {
    // Add routes
    $routeProvider.when('/status/:cardId', {
      templateUrl: 'modules/app/status/status-detail.html',
      controller: id + ".Detail",
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/status/:cardId/top', {
      templateUrl: 'modules/app/status/status-card.html',
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/status/:cardId/group/:groupId', {
      templateUrl: 'modules/app/status/status-group-detail.html',
      controller: id + ".GroupDetail",
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/status/:cardId/group/:groupId/activity/:activityId', {
      templateUrl: 'modules/app/status/status-group-detail.html',
      controller: id + ".GroupActivityDetail",
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/status/:cardId/person/:personId', {
      templateUrl: 'modules/app/status/status-person-detail.html',
      controller: id + ".PersonDetail",
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/status/:cardId/status/:statusId', {
      templateUrl: 'modules/app/status/status-status-detail.html',
      controller: id + ".StatusDetail",
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/status/:cardId/activity/:activityId', {
      templateUrl: 'modules/app/status/status-activity-detail.html',
      controller: id + ".ActivityDetail",
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    });
  }]).run(['CardIconMap', function (CardIconMap) {
    CardIconMap.register({
      "status": "status"
    });
  }]).controller(id + ".CardConfiguration", ["$scope", "$controller", function ($scope) {
    $scope.templateType = id;
    $scope.statuses = [];
    $scope.workingConfig.statuses = $scope.workingConfig.statuses || [];
    $scope.editing = null;
    $scope.customConfig.dialogView = [];
    $scope.addStatus = function addStatus(s) {
      delete $scope.customConfig.selectedVerb;
      $scope.clearVerb();
      $scope.customConfig.dialogView.push("addStatus");
      delete $scope.validationErrors;
      $scope.customConfig.statusToEdit = s || {
        "name": "",
        "filter": {
          "verbIds": {
            "ids": [""]
          }
        }
      };
      $scope.customConfig.isNewStatus = !s;

      // openDialog is defined by explorer.js
      $scope.openDialog('addStatus', true);
    };
    $scope.removeStatus = function removeStatus(i) {
      $scope.statuses.splice(i, 1);
      $scope.workingConfig.statuses = $scope.statuses;
      $scope.updateCardWithWorkingConfig();
    };
    $scope.saveStatus = function saveStatus() {
      // Validate
      $scope.validationErrors = [];
      if (_.isEmpty($scope.customConfig.statusToEdit.name)) {
        $scope.validationErrors.push("Please enter Simple Step Name");
      }
      if (_.isEmpty($scope.customConfig.statusToEdit.filter.verbIds.ids[0])) {
        $scope.validationErrors.push("Please select an existing verb");
      }
      if ($scope.validationErrors.length > 0) {
        return false;
      }
      if ($scope.customConfig.isNewStatus) {
        $scope.workingConfig.statuses.push($scope.customConfig.statusToEdit);
      } else {
        $scope.updateCardWithWorkingConfig();
      }
      $scope.back();
    };
    $scope.back = function back() {
      $scope.customConfig.dialogView.pop();
      delete $scope.customConfig.selectedVerb;
      if ($scope.customConfig.dialogView.length === 0) {
        //scope.dialog.show is in explorer.js
        $scope.dialog.show = false;
      } else {
        $scope.openDialog($scope.customConfig.dialogView[$scope.customConfig.dialogView.length - 1], true);
      }
    };
    $scope.$watchCollection('workingConfig.statuses', function (statuses) {
      if (!statuses) {
        return;
      }
      $scope.statuses = statuses;
      $scope.updateCardWithWorkingConfig();
    });
  }]).controller(id + ".Card", ["$scope", "CardRegistry", id + '.Utils', '$routeParams', function ($scope, CardRegistry, Utils, $routeParams) {
    // For use with /top route when embedding
    if (!$scope.cardId && $routeParams.cardId) {
      $scope.cardId = $routeParams.cardId;
    }
    $scope.config = CardRegistry.get($scope.cardId).configuration;
    $scope.defaultSummary = 'This report allows a user to explore the current status of people for each course.';
    if (!$scope.config) {
      $scope.hasData = false;
      $scope.noDataMsg = "Please configure a valid status";
      return;
    }
    Utils.fetchResultData($scope.cardId || $scope.card.id, $scope.cardToPreview).then(function (r) {
      $scope.data = r.data.results[0].result.data[0];
      $scope.statusPieChart = Utils.getResultPieChart(r.data.results[0].result.data[0], $scope.config);
      $scope.hasData = true;
    }, function () {
      $scope.hasData = false;
    });
  }]).controller(id + ".Detail", ["$scope", "$routeParams", id + ".Utils", "CardRegistry", 'Api', 'CardUtils', 'CardQueryResource', function ($scope, $routeParams, Utils, CardRegistry, Api, CardUtils, CardQueryResource) {
    $scope.cardId = $routeParams.cardId;
    $scope.card = CardRegistry.get($scope.cardId);
    $scope.config = $scope.card.configuration;
    if (!$scope.config) {
      $scope.hasData = false;
      $scope.noDataMsg = "Please configure a valid status";
      return;
    }
    var isPreview = $scope.cardId === 'preview',
      cardToPreview = isPreview ? $scope.card : null;
    Utils.fetchData($scope.cardId || $scope.card.id, cardToPreview).then(function (r) {
      $scope.statuses = r.data.results[0].result.data;
      $scope.pagenote.setReportMetadata({
        processedHits: _.reduce($scope.statuses, function (sum, s) {
          return sum + s.count;
        }, 0)
      });
      $scope.statusPieChart = Utils.getStatusPieChart($scope.statuses, $scope.config);
      $scope.hasData = true;
    }, function () {
      $scope.hasData = false;
    });
    $scope.getDetailURL = Utils.getDetailURL;
    CardUtils.setNavElements($scope, $scope.cardId, $scope.cardId);
    $scope.subDetails = [{
      text: "Download data",
      downloadData: true,
      tooltip: "Download data tables",
      href: CardQueryResource.getDownloadUrl('status/states/csv', $scope.cardId, $scope.config)
    }, {
      text: "Download interaction statements",
      downloadData: true,
      tooltip: "Download interaction statements",
      callback: Utils.getStatementDownloadUrl($scope.cardId === 'preview' ? $scope.config.filter : $scope.cardId)
    }];
    $scope.pagenote = {
      "clearCacheAction": "cards/" + $scope.cardId + "/cache"
    };
  }]).controller(id + ".GroupDetail", ["$scope", "CardRegistry", id + '.Utils', '$routeParams', 'Groups', 'CardUtils', function ($scope, CardRegistry, Utils, $routeParams, Groups, CardUtils) {
    // For use with /top route when embedding
    if (!$scope.cardId && $routeParams.cardId) {
      $scope.cardId = $routeParams.cardId;
    }
    $scope.card = CardRegistry.get($scope.cardId);
    $scope.config = $scope.card.configuration;
    $scope.defaultSummary = 'Status default summary';
    if (!$scope.config) {
      $scope.hasData = false;
      $scope.noDataMsg = "Please configure a valid status";
      return;
    }
    $scope.getDetailURL = Utils.getDetailURL;
    Groups.get($routeParams.groupId).then(function (group) {
      $scope.group = group;
      CardUtils.setNavElements($scope, $scope.group.name, $scope.cardId);
    });
  }]).controller(id + ".PersonDetail", ["$scope", "CardRegistry", id + '.Utils', '$routeParams', 'People', 'CardUtils', function ($scope, CardRegistry, Utils, $routeParams, People, CardUtils) {
    // For use with /top route when embedding
    if (!$scope.cardId && $routeParams.cardId) {
      $scope.cardId = $routeParams.cardId;
    }
    $scope.card = CardRegistry.get($scope.cardId);
    $scope.config = $scope.card.configuration;
    $scope.defaultSummary = 'Status default summary';
    if (!$scope.config) {
      $scope.hasData = false;
      $scope.noDataMsg = "Please configure a valid status";
      return;
    }
    $scope.getDetailURL = Utils.getDetailURL;
    People.get($routeParams.personId).then(function (r) {
      $scope.person = r;
      CardUtils.setNavElements($scope, $scope.person.name, $scope.cardId);
    });
  }]).controller(id + ".StatusDetail", ["$scope", "CardRegistry", id + '.Utils', '$routeParams', function ($scope, CardRegistry, Utils, $routeParams) {
    // For use with /top route when embedding
    if (!$scope.cardId && $routeParams.cardId) {
      $scope.cardId = $routeParams.cardId;
    }
    $scope.card = CardRegistry.get($scope.cardId);
    $scope.config = $scope.card.configuration;
    $scope.defaultSummary = 'Status default summary';
    if (!$scope.config) {
      $scope.hasData = false;
      $scope.noDataMsg = "Please configure a valid status";
      return;
    }
    $scope.getDetailURL = Utils.getDetailURL;
    $scope.status = $scope.config.statuses[$routeParams.statusId];
  }]).controller(id + ".ActivityDetail", ["$scope", "CardRegistry", id + '.Utils', '$routeParams', 'Activities', 'CardUtils', function ($scope, CardRegistry, Utils, $routeParams, Activities, CardUtils) {
    // For use with /top route when embedding
    if (!$scope.cardId && $routeParams.cardId) {
      $scope.cardId = $routeParams.cardId;
    }
    $scope.card = CardRegistry.get($scope.cardId);
    $scope.config = $scope.card.configuration;
    $scope.defaultSummary = 'Status default summary';
    if (!$scope.config) {
      $scope.hasData = false;
      $scope.noDataMsg = "Please configure a valid status";
      return;
    }
    $scope.getDetailURL = Utils.getDetailURL;
    Activities.multiGetByActivityId([decodeURIComponent($routeParams.activityId)]).then(function (r) {
      $scope.activity = r.results[0];
      CardUtils.setNavElements($scope, $scope.activity.name, $scope.cardId);
    });
  }]).controller(id + ".GroupActivityDetail", ["$scope", "CardRegistry", id + '.Utils', '$routeParams', 'Groups', 'Activities', 'CardUtils', '$q', function ($scope, CardRegistry, Utils, $routeParams, Groups, Activities, CardUtils, $q) {
    // For use with /top route when embedding
    if (!$scope.cardId && $routeParams.cardId) {
      $scope.cardId = $routeParams.cardId;
    }
    $scope.card = CardRegistry.get($scope.cardId);
    $scope.config = $scope.card.configuration;
    $scope.defaultSummary = 'Status default summary';
    if (!$scope.config) {
      $scope.hasData = false;
      $scope.noDataMsg = "Please configure a valid status";
      return;
    }
    $scope.getDetailURL = Utils.getDetailURL;
    $q.all([Groups.get($routeParams.groupId), Activities.multiGetByActivityId([decodeURIComponent($routeParams.activityId)])]).then(function (r) {
      $scope.group = r[0];
      $scope.activity = r[1].results[0];
      CardUtils.setNavElements($scope, $scope.group.name, $scope.cardId);
      CardUtils.setNavElements($scope, $scope.activity.name, $scope.cardId);
    });
  }]).controller(id + ".StatusModal", ["$scope", "CardRegistry", id + '.Utils', '$routeParams', '$uibModalInstance', function ($scope, CardRegistry, Utils, $routeParams, $uibModalInstance) {
    // For use with /top route when embedding
    if (!$scope.cardId && $routeParams.cardId) {
      $scope.cardId = $routeParams.cardId;
    }
    $scope.title = ($scope.activity || $scope.group || $scope.person ? '' : $scope.card.title + ' - ') + ($scope.activity ? $scope.activity.name + ' - ' : '') + ($scope.person ? $scope.person.name + ' - ' : '') + ($scope.group ? $scope.group.name + ' - ' : '') + (!$scope.isComplete ? 'Not ' : '') + 'Completed List';
    $scope.statusFilter = {};
    if ($scope.selectedStatus) {
      if (_.isArray($scope.selectedStatus)) {
        $scope.statusFilter.id = _.map($scope.selectedStatus, function (status) {
          return $scope.config.statuses.indexOf(status);
        });
      } else if (_.isNumber($scope.selectedStatus.id)) {
        $scope.statusFilter.id = $scope.selectedStatus.id.toString();
      }
    }
    var params = {
      order_by: 'name',
      _limit: 10,
      statusId: $scope.statusFilter.id
    };
    $scope.activityTypeahead = function activityTypeahead(query, person) {
      return Utils.fetchActivityData($scope.cardId || $scope.card.id, null, _.extend(params, {
        in_name: query,
        personId: person && person.personId
      })).then(function (r) {
        return r.data.results[0].result.data;
      });
    };
    $scope.personTypeahead = function personTypeahead(query, activity) {
      return Utils.fetchPeopleData($scope.cardId || $scope.card.id, null, _.extend(params, {
        in_name: query,
        activityId: activity && activity.activityId
      })).then(function (r) {
        return r.data.results[0].result.data;
      });
    };
    $scope.close = function () {
      $uibModalInstance.dismiss();
    };
  }]).controller(id + '.CompletionChart', ['$scope', '$q', id + ".Utils", '$routeParams', 'CardRegistry', '$uibModal', function ($scope, $q, Utils, $routeParams, CardRegistry, $uibModal) {
    $scope.cardId = $routeParams.cardId;
    $scope.card = CardRegistry.get($scope.cardId);
    $scope.config = $scope.card.configuration;
    $scope.downloadUrl = Utils.getCsvDownloadUrl('people', $scope.cardId, $scope.config);
    if (!$scope.config) {
      $scope.hasData = false;
      $scope.noDataMsg = "Please configure a valid status";
      return;
    }
    var isPreview = $scope.cardId === 'preview',
      cardToPreview = isPreview ? $scope.card : null;
    $scope.openModal = function openModal(countsAsCompletion) {
      $scope.selectedStatus = _.chain($scope.config.statuses).map(function (s, i) {
        s.idx = i;
        return s;
      }).filter(function (s) {
        return s.countsAsCompletion === countsAsCompletion;
      }).value();
      $scope.isComplete = countsAsCompletion;
      $uibModal.open({
        templateUrl: 'modules/app/status/status-modal.html',
        controller: id + '.StatusModal',
        backdrop: 'static',
        size: 'lg',
        scope: $scope
      });
    };
    Utils.fetchResultData($scope.cardId || $scope.card.id, cardToPreview).then(function (r) {
      $scope.result = r.data.results[0].result.data[0];
      if ($scope.person) {
        $scope.result.personName = $scope.person.name;
      }
      $scope.completionPieChart = Utils.getResultPieChart($scope.result, $scope.config);
    });
  }]).controller(id + '.StatusChart', ['$scope', '$q', id + ".Utils", '$routeParams', 'CardRegistry', '$uibModal', function ($scope, $q, Utils, $routeParams, CardRegistry, $uibModal) {
    $scope.cardId = $routeParams.cardId;
    $scope.card = CardRegistry.get($scope.cardId);
    $scope.config = $scope.card.configuration;
    $scope.downloadUrl = Utils.getCsvDownloadUrl('people', $scope.cardId, $scope.config);
    if (!$scope.config) {
      $scope.hasData = false;
      $scope.noDataMsg = "Please configure a valid status";
      return;
    }
    var isPreview = $scope.cardId === 'preview',
      cardToPreview = isPreview ? $scope.card : null;
    $scope.openModal = function openModal(status) {
      $scope.selectedStatus = status;
      $uibModal.open({
        templateUrl: 'modules/app/status/status-modal.html',
        controller: id + '.StatusModal',
        backdrop: 'static',
        size: 'lg',
        scope: $scope
      });
    };
    Utils.fetchData($scope.cardId || $scope.card.id, cardToPreview).then(function (r) {
      $scope.statuses = r.data.results[0].result.data;
      $scope.statusPieChart = Utils.getStatusPieChart($scope.statuses, $scope.config);
    });
  }]).controller(id + '.PersonLister', ['$scope', '$q', id + ".Utils", '$routeParams', '$controller', function ($scope, $q, Utils, $routeParams, $controller) {
    $scope.searchPlaceholder = "Search for a person";
    $scope.searchBy = "name";
    $scope.pageSize = 10;
    $scope.downloadUrl = Utils.getCsvDownloadUrl('people', $scope.cardId, $scope.config);
    $scope.statusFilter = {};
    if ($scope.selectedStatus) {
      if (_.isArray($scope.selectedStatus)) {
        $scope.statusFilter.id = _.map($scope.selectedStatus, function (status) {
          return $scope.config.statuses.indexOf(status);
        });
      } else if (_.isNumber($scope.selectedStatus.id)) {
        $scope.statusFilter.id = $scope.selectedStatus.id.toString();
      }
    }
    $scope.statuses = $scope.config.statuses;
    $scope.$watch('statusFilter.id', function () {
      $scope.resetPage();
    });
    $scope.showCompletionChart = !$routeParams.activityId;
    $scope.legend = Utils.getCompletionBarChartLegend('Courses', $scope.config);
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    $scope.sortControls = !$scope.showCompletionChart ? [{
      "title": "Person",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Status",
      "options": {
        "Ascending": "status",
        "Descending": "-status"
      }
    }, {
      "title": "Updated",
      "options": {
        "Ascending": "time",
        "Descending": "-time"
      }
    }, {
      "title": "Score",
      "options": {
        "Ascending": "averageScore",
        "Descending": "-averageScore"
      }
    }] : [{
      "title": "Person",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Completion Rate",
      "options": {
        "Ascending": "averageCompletion",
        "Descending": "-averageCompletion"
      }
    }];
    var isPreview = $scope.cardId === 'preview',
      cardToPreview = isPreview ? $scope.card : null;
    $scope.fetchData = function fetchData(params) {
      params.statusId = $scope.statusFilter.id;
      return Utils.fetchPeopleData($scope.cardId || $scope.card.id, cardToPreview, params).then(function (r) {
        $scope.peopleLoaded = true;
        var result = r.data.results[0].result;
        _.each(result.data, function (d) {
          d.completionChart = Utils.getCompletionBarChart(d, $scope.config);
        });
        return {
          "results": result.data,
          "count": result.count
        };
      });
    };
    $scope.fetchSearchSuggestions = function (params) {
      if (!params.in_name || params.in_name.length < 3) {
        return $q.resolve({
          "results": [],
          "count": 0
        });
      }
      params._limit = 10;
      params._offset = 0;
      return $scope.fetchData(params);
    };
  }]).controller(id + '.GroupLister', ['$scope', '$q', id + ".Utils", '$routeParams', '$controller', function ($scope, $q, Utils, $routeParams, $controller) {
    $scope.searchPlaceholder = "Search for a group";
    $scope.searchBy = "name";
    $scope.pageSize = 10;
    $scope.downloadUrl = Utils.getCsvDownloadUrl('groups', $scope.cardId, $scope.config);
    $scope.showStatus = $routeParams.activityId;
    $scope.legend = Utils.getCompletionBarChartLegend('Group', $scope.config);
    $scope.statusLegend = Utils.getStatusBarChartLegend($scope.config);
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    $scope.sortControls = [{
      "title": "Group",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Completion Rate",
      "options": {
        "Ascending": "averageCompletion",
        "Descending": "-averageCompletion"
      }
    }];
    var isPreview = $scope.cardId === 'preview',
      cardToPreview = isPreview ? $scope.card : null;
    $scope.fetchData = function fetchData(params) {
      return Utils.fetchGroupData($scope.cardId || $scope.card.id, cardToPreview, params, $scope.person || $scope.group).then(function (r) {
        $scope.groupsLoaded = true;
        var result = r.data.results[0].result;
        _.each(result.data, function (d) {
          d.completionChart = Utils.getCompletionBarChart(d, $scope.config);
          d.statusChart = Utils.getStatusBarChart(d, $scope.config);
        });
        return {
          "results": result.data,
          "count": result.count
        };
      });
    };
    $scope.fetchSearchSuggestions = function (params) {
      if (!params.in_name || params.in_name.length < 3) {
        return $q.resolve({
          "results": [],
          "count": 0
        });
      }
      params._limit = 10;
      params._offset = 0;
      return $scope.fetchData(params);
    };
  }]).controller(id + '.ActivityLister', ['$scope', '$q', id + ".Utils", '$routeParams', '$controller', function ($scope, $q, Utils, $routeParams, $controller) {
    $scope.searchPlaceholder = "Search for a course";
    $scope.searchBy = "name";
    $scope.pageSize = 10;
    $scope.statusFilter = {};
    if ($scope.selectedStatus && _.isNumber($scope.selectedStatus.id)) {
      $scope.statusFilter.id = $scope.selectedStatus.id.toString();
    }
    $scope.statuses = $scope.config.statuses;
    $scope.$watch('statusFilter.id', function () {
      $scope.resetPage();
    });
    $scope.personView = !!$routeParams.personId;
    $scope.downloadUrl = Utils.getCsvDownloadUrl('activities', $scope.cardId, $scope.config);
    $scope.legend = Utils.getCompletionBarChartLegend('People', $scope.config);
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    $scope.sortControls = $scope.personView ? [{
      "title": "Course",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Status",
      "options": {
        "Ascending": "status",
        "Descending": "-status"
      }
    }, {
      "title": "Status Recorded",
      "options": {
        "Ascending": "time",
        "Descending": "-time"
      }
    }, {
      "title": "Complete",
      "options": {
        "Ascending": "completionCount",
        "Descending": "-completionCount"
      }
    }, {
      "title": "Score",
      "options": {
        "Ascending": "averageScore",
        "Descending": "-averageScore"
      }
    }] : [{
      "title": "Course",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Completion",
      "options": {
        "Ascending": "averageCompletion",
        "Descending": "-averageCompletion"
      }
    }];
    var isPreview = $scope.cardId === 'preview',
      cardToPreview = isPreview ? $scope.card : null;
    $scope.fetchData = function fetchData(params) {
      params.statusId = $scope.statusFilter.id;
      return Utils.fetchActivityData($scope.cardId || $scope.card.id, cardToPreview, params).then(function (r) {
        $scope.activitiesLoaded = true;
        var result = r.data.results[0].result;
        _.each(result.data, function (d) {
          d.completionChart = Utils.getCompletionBarChart(d, $scope.config);
        });
        return {
          "results": result.data,
          "count": result.count
        };
      });
    };
    $scope.fetchSearchSuggestions = function (params) {
      if (!params.in_name || params.in_name.length < 3) {
        return $q.resolve({
          "results": [],
          "count": 0
        });
      }
      params._limit = 10;
      params._offset = 0;
      return $scope.fetchData(params);
    };
  }]).controller(id + '.StateLister', ['$scope', '$q', id + ".Utils", '$routeParams', '$controller', function ($scope, $q, Utils, $routeParams, $controller) {
    $scope.searchPlaceholder = "Search for a person";
    $scope.defaultSearchBy = "personName";
    $scope.pageSize = 10;
    $scope.statuses = $scope.config.statuses;
    $scope.downloadUrl = Utils.getCsvDownloadUrl('states', $scope.cardId, $scope.config, {
      statusId: $scope.statusFilter.id,
      personId: $scope.selectedPerson && $scope.selectedPerson.id,
      activityId: $scope.selectedActivity && $scope.selectedActivity.activityId
    });
    $scope.$watch('statusFilter.id', function () {
      $scope.resetPage();
    });
    $scope.personSelected = function (person) {
      $scope.selectedPerson = person;
      $scope.resetPage();
    };
    $scope.activitySelected = function (activity) {
      $scope.selectedActivity = activity;
      $scope.resetPage();
    };
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    $scope.sortControls = [{
      "title": "Person",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Course",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Course Status",
      "options": {
        "Ascending": "status",
        "Descending": "-status"
      }
    }, {
      "title": "Updated",
      "options": {
        "Ascending": "time",
        "Descending": "-time"
      }
    }, {
      "title": "Score",
      "options": {
        "Ascending": "averageScore",
        "Descending": "-averageScore"
      }
    }];
    var isPreview = $scope.cardId === 'preview',
      cardToPreview = isPreview ? $scope.card : null;
    $scope.fetchData = function fetchData(params) {
      params.statusId = $scope.statusFilter.id;
      params.personId = $scope.selectedPerson && $scope.selectedPerson.personId;
      params.activityId = $scope.selectedActivity && $scope.selectedActivity.activityId;
      return Utils.fetchStatusStateData($scope.cardId || $scope.card.id, cardToPreview, params).then(function (r) {
        $scope.statesLoaded = true;
        var result = r.data.results[0].result;
        return {
          "results": result.data,
          "count": result.count
        };
      });
    };
    $scope.fetchSearchSuggestions = function (params) {
      if (!params.in_name || params.in_name.length < 3) {
        return $q.resolve({
          "results": [],
          "count": 0
        });
      }
      params._limit = 10;
      params._offset = 0;
      return $scope.fetchData(params);
    };
  }]).controller(id + '.StatusLister', ['$scope', '$q', id + ".Utils", '$routeParams', '$controller', function ($scope, $q, Utils, $routeParams, $controller) {
    $scope.searchPlaceholder = "Search for a status";
    $scope.searchBy = "name";
    $scope.pageSize = 10;
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    $scope.sortControls = [{
      "title": "Status",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Count",
      "options": {
        "Ascending": "count",
        "Descending": "-count"
      }
    }, {
      "title": "People",
      "options": {
        "Ascending": "personCount",
        "Descending": "-personCount"
      }
    }, {
      "title": "Courses",
      "options": {
        "Ascending": "activityCount",
        "Descending": "-activityCount"
      }
    }, {
      "title": "Success Rate",
      "options": {
        "Ascending": "averageSuccess",
        "Descending": "-averageSuccess"
      }
    }, {
      "title": "Average Score",
      "options": {
        "Ascending": "averageScore",
        "Descending": "-averageScore"
      }
    }, {
      "title": "Average Time Spent",
      "options": {
        "Ascending": "averageDuration",
        "Descending": "-averageDuration"
      }
    }];
    var isPreview = $scope.cardId === 'preview',
      cardToPreview = isPreview ? $scope.card : null;
    $scope.fetchData = function fetchData(params) {
      return Utils.fetchData($scope.cardId || $scope.card.id, cardToPreview, params).then(function (r) {
        $scope.statusesLoaded = true;
        var result = r.data.results[0].result;
        return {
          "results": result.data,
          "count": result.count
        };
      });
    };
    $scope.fetchSearchSuggestions = function (params) {
      if (!params.in_name || params.in_name.length < 3) {
        return $q.resolve({
          "results": [],
          "count": 0
        });
      }
      params._limit = 10;
      params._offset = 0;
      return $scope.fetchData(params);
    };
  }]);
})();
